<template>
  <UserEdit v-if="user" :userId="user"/>
</template>

<script>
import UserEdit from "@/components/UserEdit";

export default {
  name: "Profile",
  components: {UserEdit},
  data: () => ({
    user: null
  }),
  mounted() {
    this.user = this.$httpUserApi.userId();
  }
}
</script>

<style scoped>

</style>
